<template>
  <v-container>
    <v-row class="mb-0">
      <v-col cols="12">
        <h1 class="justify-left mb-3 mt-0" v-if="$vuetify.breakpoint.smAndUp">
          Create New User
        </h1>
      </v-col>
    </v-row>
    <v-row class="mt-1 justify-left">
      <v-col cols="12" sm="8" md="5" class="pa-0">
        <v-col cols="12" class="py-0 input-feild-container">
          <v-text-field
            outlined
            v-model="userInfo.name"
            v-restrict-input
            minLength="1"
            maxLength="40"
            @input="$v.userInfo.name.$touch()"
            @change="$v.userInfo.name.$touch()"
            @blur="$v.userInfo.name.$touch()"
            :error-messages="$errorMessages($v.userInfo.name, 'User Name')"
            color="#293897"
            label="Name"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="py-0">
          <v-text-field
            outlined
            type="number"
            v-model="userInfo.mob"
            @input="$v.userInfo.mob.$touch()"
            @change="$v.userInfo.mob.$touch()"
            @blur="$v.userInfo.mob.$touch()"
            v-restrict-input
            maxLength="10"
            minLength="10"
            :error-messages="$errorMessages($v.userInfo.mob, 'Mobile Number')"
            color="#293897"
            label="Mobile Number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="py-0">
          <v-text-field
            outlined
            v-model="userInfo.email"
            @input="$v.userInfo.email.$touch()"
            @change="$v.userInfo.email.$touch()"
            @blur="$v.userInfo.email.$touch()"
            :error-messages="$errorMessages($v.userInfo.email, 'Email')"
            color="#293897"
            label="Email ID"
          ></v-text-field>
        </v-col>
        <v-row class="ma-0 mt-1 justify-center mob-fixed">
          <v-col cols="6" class="py-0">
            <v-btn
              outlined
              color="#293897"
              @click="navigateManageUser"
              large
              width="100%"
              class="cancel-button"
              >Cancel</v-btn
            >
          </v-col>
          <v-col cols="6" class="py-0">
            <v-btn
              primary
              width="100%"
              large
              class="primary-btn submit-button"
              @click="createUser"
              >Submit</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" persistent max-width="380">
      <v-card class="text-center pa-5">
        <img src="@/assets/User-created.svg" class="mt-4" />
        <v-card-title class="title font-weight-bold">
          Login ID successfully created </v-card-title
        ><v-card-subtitle
          class="body-1 spiceblue--text py-3 font-weight-medium"
        >
          {{ userInfo.name }}
        </v-card-subtitle>
        <v-card-text>
          The login credentials have been successfully shared on the registered
          Email ID.</v-card-text
        >
        <v-card-actions class="justify-center mb-4">
          <v-btn
            dark
            depressed
            color="#293897"
            large
            width="160px"
            @click="navigateManageUser"
            >Okay</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import CreateUser from "./createUser.ts";
export default CreateUser;
</script>
<style lang="css" src="./createUser.css" scoped />